import { CustomerNumber } from '../../types';
import { CustomerFeature } from '../../types/customer-feature.type';

export interface CustomerState {
    fetchingCustomerNumbers: boolean;
    customerNumbers: CustomerNumber[];
    customerNumbersError: any | null;
    activeCustomerNumber: CustomerNumber | null;
    numberSelectionDialogVisible: boolean;
    fetchingFeatures: boolean;
    features: CustomerFeature | null;
    featuresError: any | null;
    customerName: string;
}

export const GET_CUSTOMER_NUMBERS = 'GET_CUSTOMER_NUMBERS';
export const GET_CUSTOMER_NUMBERS_SUCCESS = 'GET_CUSTOMER_NUMBERS_SUCCESS';
export const GET_CUSTOMER_NUMBERS_ERROR = 'GET_CUSTOMER_NUMBERS_ERROR';

export interface GetCustomerNumbersAction {
    type: typeof GET_CUSTOMER_NUMBERS;
}
export interface GetCustomerNumbersSuccessAction {
    type: typeof GET_CUSTOMER_NUMBERS_SUCCESS;
    payload: {
        customerNumbers: CustomerNumber[];
    };
}

export interface GetCustomerNumbersErrorAction {
    type: typeof GET_CUSTOMER_NUMBERS_ERROR;
    payload: {
        error: any;
    };
}

export const SET_ACTIVE_CUSTOMER_NUMBER = 'SET_ACTIVE_CUSTOMER_NUMBER';

export interface SetActiveCustomerNumberAction {
    type: typeof SET_ACTIVE_CUSTOMER_NUMBER;
    payload: {
        customerNumber: CustomerNumber;
    };
}
export const SHOW_NUMBER_SELECTION_DIALOG = 'SHOW_NUMBER_SELECTION_DIALOG';
export const HIDE_NUMBER_SELECTION_DIALOG = 'HIDE_NUMBER_SELECTION_DIALOG';
export interface ShowNumberSelectionDialogAction {
    type: typeof SHOW_NUMBER_SELECTION_DIALOG;
}

export interface HideNumberSelectionDialogAction {
    type: typeof HIDE_NUMBER_SELECTION_DIALOG;
}

export const GET_CUSTOMER_FEATURES = 'GET_CUSTOMER_FEATURES';
export const GET_CUSTOMER_FEATURES_SUCCESS = 'GET_CUSTOMER_FEATURES_SUCCESS';
export const GET_CUSTOMER_FEATURES_ERROR = 'GET_CUSTOMER_FEATURES_ERROR';

export interface GetCustomerFeaturesAction {
    type: typeof GET_CUSTOMER_FEATURES;
}

export interface GetCustomerFeaturesSuccessAction {
    type: typeof GET_CUSTOMER_FEATURES_SUCCESS;
    payload: {
        features: CustomerFeature;
    };
}

export interface GetCustomerFeaturesErrorAction {
    type: typeof GET_CUSTOMER_FEATURES_ERROR;
    payload: {
        error: string;
    };
}

export const SET_CUSTOMER_NAME = 'SET_CUSTOMER_NAME';
export interface SetCustomerNameAction {
    type: typeof SET_CUSTOMER_NAME;
    payload: {
        customerName: string;
    };
}

export type CustomerActionTypes =
    | GetCustomerNumbersAction
    | GetCustomerNumbersSuccessAction
    | GetCustomerNumbersErrorAction
    | SetActiveCustomerNumberAction
    | ShowNumberSelectionDialogAction
    | HideNumberSelectionDialogAction
    | GetCustomerFeaturesAction
    | GetCustomerFeaturesSuccessAction
    | GetCustomerFeaturesErrorAction
    | SetCustomerNameAction;
